module.exports = __webpack_public_path__ + "img/sustainable-bw.f01fdbb0.png";